var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hero-name-level"},[_c('span',[_vm._v(" "+_vm._s(_vm.classToName(_vm.hero.class))+" ")]),_c('span',[_vm._v("·")]),_c('span',{staticClass:"text-monospace font-weight-bold"},[_vm._v(" "+_vm._s(_vm.hero.level)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }